<!-- =========================================================================================
  File Name: TheNavbar.vue
  Description: Navbar component
  Component Name: TheNavbar

========================================================================================== -->

<template>
	<div class="relative">
		<div class="vx-navbar-wrapper" :class="classObj">
			<vs-navbar class="vx-navbar navbar-custom navbar-skelton" :color="navbarColorLocal">
				<!-- SM - OPEN SIDEBAR BUTTON -->
				<feather-icon class="sm:inline-flex xl:hidden cursor-pointer mr-1" icon="MenuIcon" @click.stop="showSidebar"></feather-icon>

				<template v-if="windowWidth >= 992">
					<!-- STARRED PAGES - FIRST 10 -->
					<ul class="vx-navbar__starred-pages">
						<draggable v-model="starredPagesLimited" :group="{ name: 'pinList' }" class="flex cursor-move">
							<li class="starred-page" v-for="page in starredPagesLimited" :key="page.url">
								<vx-tooltip :text="page.label" position="bottom" delay=".3s">
									<feather-icon svgClasses="h-6 w-6" class="p-2 cursor-pointer" :icon="page.labelIcon" @click="$router.push(page.url).catch(() => {})" />
								</vx-tooltip>
							</li>
						</draggable>
					</ul>

					<!-- STARRED PAGES MORE -->
					<div class="vx-navbar__starred-pages--more-dropdown" v-if="starredPagesMore.length">
						<vs-dropdown vs-custom-content vs-trigger-click>
							<feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" class="cursor-pointer p-2"></feather-icon>
							<vs-dropdown-menu>
								<ul class="vx-navbar__starred-pages-more--list">
									<draggable v-model="starredPagesMore" :group="{ name: 'pinList' }" class="cursor-move">
										<li
											class="starred-page--more flex items-center cursor-pointer"
											v-for="page in starredPagesMore"
											:key="page.url"
											@click="$router.push(page.url).catch(() => {})"
										>
											<feather-icon svgClasses="h-5 w-5" class="ml-2 mr-1" :icon="page.labelIcon"></feather-icon>
											<span class="px-2 pt-2 pb-1">{{ page.label }}</span>
										</li>
									</draggable>
								</ul>
							</vs-dropdown-menu>
						</vs-dropdown>
					</div>

					<div class="bookmark-container" v-if="false">
						<feather-icon
							icon="StarIcon"
							:svgClasses="['stoke-current text-warning', { 'text-white': navbarColor !== '#fff' }]"
							class="cursor-pointer p-2"
							@click.stop="showBookmarkPagesDropdown = !showBookmarkPagesDropdown"
						/>
						<div v-click-outside="outside" class="absolute bookmark-list w-1/3 xl:w-1/4 mt-4" v-if="showBookmarkPagesDropdown">
							<vx-auto-suggest
								:autoFocus="true"
								:data="navbarSearchAndPinList"
								@selected="selected"
								@actionClicked="actionClicked"
								inputClassses="w-full"
								show-action
								show-pinned
								background-overlay
							></vx-auto-suggest>
						</div>
					</div>
				</template>

				<vs-spacer />

				<!-- SEARCHBAR -->

				<!-- USER META -->
				<div class="the-navbar__user-meta flex items-center" v-if="activeUserInfo.first_name">
					<!-- NOTIFICATIONS -->
					<dropdown-notifications></dropdown-notifications>
					<!-- END NOTIFICATIONS -->

					<vs-button class="font-bold mr-4 whitespace-no-wrap" @click.stop="changeRole">Đổi vai trò</vs-button>

					<div class="text-right leading-tight hidden sm:block">
						<p class="font-semibold">{{ user_displayName }}</p>
						<small>{{ clusterName }}</small>
					</div>
					<vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer" ref="menuRef">
						<div class="con-img ml-3">
							<img v-if="activeUserImg" key="onlineImg" :src="activeUserImg" alt="user-img" width="40" height="40" class="rounded-full shadow-md cursor-pointer block" />
						</div>
						<vs-dropdown-menu class="vx-navbar-dropdown">
							<ul style="min-width: 11rem">
								<li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white" @click="handleClickMenuWithCallback(() => $router.push('/pages/profile').catch(() => {}))">
									<feather-icon icon="UserIcon" svgClasses="w-4 h-4" />
									<span class="ml-2">{{ $t("Profile") }}</span>
								</li>
								<li
									v-if="$store.state.AppActiveUser.role.is_student"
									class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
									@click="handleClickMenuWithCallback(() => $router.push({ name: 'student-profile', params: { studentId: $store.state.AppActiveUser.role.id } }).catch(() => {}))"
								>
									<feather-icon icon="UsersIcon" svgClasses="w-4 h-4" />
									<span class="ml-2">{{ $t("ProfileDormitory.ProfileStudent") }}</span>
								</li>
								<!-- <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white" @click="$router.push('/apps/email').catch(() => {})">
									<feather-icon icon="MailIcon" svgClasses="w-4 h-4" />
									<span class="ml-2">Inbox</span>
								</li>
								<li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white" @click="$router.push('/apps/todo').catch(() => {})">
									<feather-icon icon="CheckSquareIcon" svgClasses="w-4 h-4" />
									<span class="ml-2">Tasks</span>
								</li>
								<li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white" @click="$router.push('/apps/chat').catch(() => {})">
									<feather-icon icon="MessageSquareIcon" svgClasses="w-4 h-4" />
									<span class="ml-2">Chat</span>
								</li>
								-->
								<vs-divider class="m-1"></vs-divider>

								<li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white" @click="logout">
									<feather-icon icon="LogOutIcon" svgClasses="w-4 h-4" />
									<span class="ml-2">{{ $t("Logout") }}</span>
								</li>
							</ul>
						</vs-dropdown-menu>
					</vs-dropdown>
				</div>
			</vs-navbar>
		</div>
	</div>
</template>

<script>
import i18n from "@/i18n.js";

import draggable from "vuedraggable";
import VxAutoSuggest from "@/components/vx-auto-suggest/VxAutoSuggest.vue";
import DropdownNotifications from "../../../views/apps/notifications/DropdownNotifications.vue";

export default {
	name: "the-navbar",
	props: {
		navbarColor: {
			type: String,
			default: "#fff"
		}
	},
	data() {
		return {
			navbarSearchAndPinList: this.$store.state.navbarSearchAndPinList,
			searchQuery: "",
			showFullSearch: false,

			settings: {
				// perfectscrollbar settings
				maxScrollbarLength: 60,
				wheelSpeed: 0.6
			},
			autoFocusSearch: false,
			showBookmarkPagesDropdown: false
		};
	},
	watch: {
		$route() {
			if (this.showBookmarkPagesDropdown) this.showBookmarkPagesDropdown = false;
		}
	},
	computed: {
		navbarColorLocal() {
			return this.$store.state.theme === "dark" ? "#10163a" : this.navbarColor;
		},
		// HELPER
		verticalNavMenuWidth() {
			return this.$store.state.verticalNavMenuWidth;
		},
		windowWidth() {
			return this.$store.state.windowWidth;
		},

		// NAVBAR STYLE
		classObj() {
			if (this.verticalNavMenuWidth == "default") return "navbar-default";
			else if (this.verticalNavMenuWidth == "reduced") return "navbar-reduced";
			else if (this.verticalNavMenuWidth) return "navbar-full";
		},

		// I18N
		getCurrentLocaleData() {
			const locale = this.$i18n.locale;
			if (locale == "en") return { flag: "us", lang: "English" };
			else if (locale == "vi") return { flag: "vi", lang: "Vietnamese" };
		},
		i18n_locale_img() {
			return require(`@/assets/images/flags/${this.$i18n.locale}.png`);
		},

		// BOOKMARK & SEARCH
		data() {
			return this.$store.state.navbarSearchAndPinList;
		},
		starredPages() {
			return this.$store.state.starredPages;
		},
		starredPagesLimited: {
			get() {
				return this.starredPages.slice(0, 10);
			},
			set(list) {
				this.$store.dispatch("arrangeStarredPagesLimited", list);
			}
		},
		starredPagesMore: {
			get() {
				return this.starredPages.slice(10);
			},
			set(list) {
				this.$store.dispatch("arrangeStarredPagesMore", list);
			}
		},

		// PROFILE
		activeUserInfo() {
			return this.$store.state.AppActiveUser;
		},
		user_displayName() {
			return (this.activeUserInfo.role && this.activeUserInfo.role.name) || "";
		},
		activeUserImg() {
			return (this.$store.state.AppActiveUser.role && this.$store.state.AppActiveUser.role.avatar) || "";
		},

		clusterName() {
			return (this.activeUserInfo.role && this.activeUserInfo.role.cluster && this.activeUserInfo.role.cluster.company.name) || "";
		}
	},
	methods: {
		updateLocale(locale) {
			i18n.locale = locale;
			this.$validator.localize(locale);
		},
		showSidebar() {
			this.$store.commit("TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE", true);
		},
		selected(item) {
			this.$router.push(item.url).catch(() => {});
			this.showFullSearch = false;
		},
		actionClicked(item) {
			// e.stopPropogation();
			this.$store.dispatch("updateStarredPage", {
				index: item.index,
				val: !item.highlightAction
			});
		},
		showNavbarSearch() {
			this.showFullSearch = true;
		},
		showSearchbar() {
			this.showFullSearch = true;
		},
		elapsedTime(startTime) {
			let x = new Date(startTime);
			let now = new Date();
			var timeDiff = now - x;
			timeDiff /= 1000;

			var seconds = Math.round(timeDiff);
			timeDiff = Math.floor(timeDiff / 60);

			var minutes = Math.round(timeDiff % 60);
			timeDiff = Math.floor(timeDiff / 60);

			var hours = Math.round(timeDiff % 24);
			timeDiff = Math.floor(timeDiff / 24);

			var days = Math.round(timeDiff % 365);
			timeDiff = Math.floor(timeDiff / 365);

			var years = timeDiff;

			if (years > 0) {
				return years + (years > 1 ? " Years " : " Year ") + "ago";
			} else if (days > 0) {
				return days + (days > 1 ? " Days " : " Day ") + "ago";
			} else if (hours > 0) {
				return hours + (hours > 1 ? " Hrs " : " Hour ") + "ago";
			} else if (minutes > 0) {
				return minutes + (minutes > 1 ? " Mins " : " Min ") + "ago";
			} else if (seconds > 0) {
				return seconds + (seconds > 1 ? " sec ago" : "just now");
			}

			return "Just Now";
		},
		async logout() {
			await this.$router.push("/").catch(() => {});
			localStorage.removeItem("userInfo");
			localStorage.removeItem("activeEmployee");

			// If JWT login
			this.$store.dispatch("resetStore");
			if (localStorage.getItem("accessToken")) {
				localStorage.removeItem("accessToken");
				this.$router.push("/pages/login").catch(() => {});
			}

			// Change role on logout. Same value as initialRole of acj.js
			this.$acl.change("guest");

			// This is just for demo Purpose. If user clicks on logout -> redirect
			this.$router.push("/pages/login").catch(() => {});
		},
		async changeRole() {
			this.$router.push("/pages/change-role").catch(() => {});
			// await this.$router.push("/").catch(() => {});
			// localStorage.removeItem("userInfo");

			// // If JWT login
			// this.$store.dispatch("resetStore");
			// if (localStorage.getItem("accessToken")) {
			// 	localStorage.removeItem("accessToken");
			// 	this.$router.push("/pages/login").catch(() => {});
			// }

			// // Change role on logout. Same value as initialRole of acj.js
			// this.$acl.change("guest");

			// // This is just for demo Purpose. If user clicks on logout -> redirect
			// this.$router.push("/pages/login").catch(() => {});
		},
		outside: function() {
			this.showBookmarkPagesDropdown = false;
		},

		// Method for creating dummy notification time
		randomDate({ hr, min, sec }) {
			let date = new Date();

			if (hr) date.setHours(date.getHours() - hr);
			if (min) date.setMinutes(date.getMinutes() - min);
			if (sec) date.setSeconds(date.getSeconds() - sec);

			return date;
		},
		handleClickMenuWithCallback(cb) {
			this.$refs.menuRef.$el.click();
			if (typeof cb !== "undefined" && typeof cb === "function") {
				cb();
			}
		},
		async getUserSetting() {
			const userSetting = await this.$store.dispatch("auth/fetchUserSettings");
			if (userSetting.locale) {
				this.updateLocale(userSetting.locale == "vn" ? "vi" : userSetting.locale);
			}
		}
	},
	directives: {
		"click-outside": {
			bind: function(el, binding) {
				const bubble = binding.modifiers.bubble;
				const handler = e => {
					if (bubble || (!el.contains(e.target) && el !== e.target)) {
						binding.value(e);
					}
				};
				el.__vueClickOutside__ = handler;
				document.addEventListener("click", handler);
			},

			unbind: function(el) {
				document.removeEventListener("click", el.__vueClickOutside__);
				el.__vueClickOutside__ = null;
			}
		}
	},
	components: {
		VxAutoSuggest,
		draggable,
		DropdownNotifications
	},
	mounted() {
		this.getUserSetting();
	}
};
</script>
